import React, { useEffect, useLayoutEffect, useRef } from "react"
import { colours } from "../colours"
import { projectFonts } from "../fonts"
import { getNestedObject } from "../../components/ApartmentFinder/Utils/hooks"
import { useStore } from "../../state/store"

export const FavouriteIcon = ({ isFavourite, showNumber, outline }, props) => {
  const iconRef = useRef()
  const favourites = useStore(state => state.favourites)
  useEffect(() => {}, [favourites])

  useLayoutEffect(() => {
    if (favourites) {
      const favouriteHolder = getNestedObject(iconRef.current.children, "favourite_no")
      const heart = getNestedObject(iconRef.current.children, "heart")
      const icon = getNestedObject(iconRef.current.children, "icon")
      const outline = getNestedObject(iconRef.current.children, "outline")
      //* Heart */
      heart.map(c => c.setAttribute("fill", isFavourite ? colours.secondaryUI : colours.primaryUI))

      outline && heart.map(c => c.setAttribute("fill", isFavourite ? colours.secondaryUI : "none"))

      outline && heart.map(c => c.setAttribute("stroke", colours.secondaryUI))
      //* Number */
      favouriteHolder.map(c =>
        c.setAttribute("fill", isFavourite ? colours.primaryUI : colours.secondaryUI)
      )
      favouriteHolder.map(c => c.setAttribute("display", showNumber ? "" : "none"))
      favouriteHolder.map(c => c.setAttribute("text-anchor", "right"))
      favouriteHolder.map(c => c.setAttribute("fontFamily", projectFonts.secondaryFont))
      favouriteHolder.map(c => (c.textContent = favourites.length))

      //* Icon */
      icon.map(c => c.setAttribute("fill", isFavourite ? colours.primaryUI : colours.secondaryUI))
      outline && icon.map(c => c.setAttribute("fill", colours.primaryUI))

      //* outline */
      outline.map(c => c.setAttribute("fill", "none"))
      outline.map(c =>
        c.setAttribute("stroke", isFavourite ? colours.secondaryUI : colours.primaryUI)
      )
      outline.map(c => c.setAttribute("strokeWidth", 1.5))
    }
  }, [favourites])

  return (
    <svg xmlns="http://www.w3.org/2000/svg" ref={iconRef} viewBox="0 0 61.92 61.92">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            d="M31,58.91A28,28,0,1,0,3,31,27.95,27.95,0,0,0,31,58.91Z"
            fill="#7b918e"
            stroke="#7b918e"
            strokeMiterlimit="10"
            strokeWidth="0.27"
          />
          <path
            d="M31,61.38A30.42,30.42,0,1,0,.55,31,30.42,30.42,0,0,0,31,61.38Z"
            fill="none"
            stroke="#7b918e"
            strokeMiterlimit="10"
            strokeWidth="1.09"
          />
          <g>
            <path
              d="M39.41,16.65c-4,0-6.25,2.06-8.07,5.11a.38.38,0,0,1-.14.14.44.44,0,0,1-.61-.14c-1.83-3.05-4.11-5.11-8.07-5.11-5.94,0-9.78,4.77-9.78,10.22,0,5.21,3,9.83,6.81,13.59A49.83,49.83,0,0,0,31,48.57a49.86,49.86,0,0,0,11.42-8.11c3.82-3.76,6.8-8.38,6.8-13.59C49.18,21.42,45.35,16.65,39.41,16.65Z"
              fill="#f2f2f3"
            />
            <path
              d="M39.41,15.77c-4,0-6.57,2.11-8.45,5-1.88-2.9-4.41-5-8.44-5-6.42,0-10.67,5.23-10.67,11.1,0,5.55,3.15,10.38,7.07,14.23a51,51,0,0,0,11.83,8.38.45.45,0,0,0,.42,0A50.58,50.58,0,0,0,43,41.1c3.92-3.85,7.07-8.68,7.07-14.23C50.07,21,45.83,15.77,39.41,15.77Zm3,24.69A49.86,49.86,0,0,1,31,48.57a49.83,49.83,0,0,1-11.41-8.11c-3.82-3.76-6.81-8.38-6.81-13.59,0-5.45,3.84-10.22,9.78-10.22,4,0,6.24,2.06,8.07,5.11a.44.44,0,0,0,.61.14.38.38,0,0,0,.14-.14c1.82-3.05,4.1-5.11,8.07-5.11,5.94,0,9.77,4.77,9.77,10.22C49.18,32.08,46.2,36.7,42.38,40.46Z"
              fill="#f2f2f3"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

// export default DynamicIcons
